var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg056Information(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.5,358c11.046,0,20-8.954,20-20v-75c0-40.804-33.196-74-74-74s-74,33.196-74,74v175c0,40.804,33.196,74,74,74 s74-33.196,74-74c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,18.748-15.252,34-34,34s-34-15.252-34-34V263 c0-18.748,15.252-34,34-34s34,15.252,34,34v75C289.5,349.046,298.454,358,309.5,358z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5,0c-40.804,0-74,33.196-74,74s33.196,74,74,74s74-33.196,74-74S297.304,0,256.5,0z M256.5,108 c-18.748,0-34-15.252-34-34s15.252-34,34-34s34,15.252,34,34S275.248,108,256.5,108z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg056Information);
export default __webpack_public_path__ + "static/media/056-information.015b01403b969ee83da7298eeb448598.svg";
export { ForwardRef as ReactComponent };